module.exports = __webpack_public_path__ + "img/AperioLogo.ddac4656.png";